/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetExpensePosition } from './AssetExpensePosition';
import {
    AssetExpensePositionFromJSON,
    AssetExpensePositionFromJSONTyped,
    AssetExpensePositionToJSON,
    AssetExpensePositionToJSONTyped,
} from './AssetExpensePosition';

/**
 * 
 * @export
 * @interface AssetExpenseRequest
 */
export interface AssetExpenseRequest {
    /**
     * 
     * @type {AssetExpensePosition}
     * @memberof AssetExpenseRequest
     */
    position: AssetExpensePosition;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseRequest
     */
    amount: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseRequest
     */
    debtorShare: number | null;
}



/**
 * Check if a given object implements the AssetExpenseRequest interface.
 */
export function instanceOfAssetExpenseRequest(value: object): value is AssetExpenseRequest {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('debtorShare' in value) || value['debtorShare'] === undefined) return false;
    return true;
}

export function AssetExpenseRequestFromJSON(json: any): AssetExpenseRequest {
    return AssetExpenseRequestFromJSONTyped(json, false);
}

export function AssetExpenseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpenseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'position': AssetExpensePositionFromJSON(json['position']),
        'amount': json['amount'],
        'debtorShare': json['debtorShare'],
    };
}

export function AssetExpenseRequestToJSON(json: any): AssetExpenseRequest {
    return AssetExpenseRequestToJSONTyped(json, false);
}

export function AssetExpenseRequestToJSONTyped(value?: AssetExpenseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': AssetExpensePositionToJSON(value['position']),
        'amount': value['amount'],
        'debtorShare': value['debtorShare'],
    };
}

